import { render, staticRenderFns } from "./AddTaskPreset.vue?vue&type=template&id=5da4259b&scoped=true&"
import script from "./AddTaskPreset.vue?vue&type=script&lang=js&"
export * from "./AddTaskPreset.vue?vue&type=script&lang=js&"
import style0 from "./AddTaskPreset.vue?vue&type=style&index=0&id=5da4259b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da4259b",
  null
  
)

export default component.exports